module.exports = __webpack_public_path__ + "static/media/3.c05610c9.jpg";